// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3db93ec4","453":"c7e7a40d","455":"6212dbba","977":"d7414aba"}[chunkId] + ".chunk.js";
};